<div class="route-links nordic-blue-50-bg surface-secondary mr-small-t">
  <div class="grid-col-12 grid-max-width no-row-gap">
    <ul class="route-links__list col-1-12 gc-medium no-list-style mr-clear" role="list">
      @for (link of links; track link.href) {
        <li class="ps-medium-y">
          <fcom-link [href]="link.href">
            {{ 'ondMarketing.ribbon.' + link.translationKey | finLocalization }}
          </fcom-link>
        </li>
      }
    </ul>
  </div>
</div>
